import {
  formatDateTime,
  formatTimeString,
  timeStringToDate,
  addDays,
  subtractDays,
  addMinutes,
  getUnixTimestamp,
  formatDuration,
  differenceInMinutes,
  endOfDay,
  startOfDay,
} from "../../../common/helpers/time";
import sortBy from "lodash/sortBy";
import { dateStringToDate } from "../../../common/helpers/time";
import { saveToDisk } from "../../../common/helpers/saveToDisk";

class InstructorAgendaController {
  constructor(
    UserService,
    $state,
    $stateParams,
    CalendarModel,
    $window,
    sessionTypes,
    VueStoreFactory,
    UsersModel,
  ) {
    this.UserService = UserService;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.CalendarModel = CalendarModel;
    this.VueStoreFactory = VueStoreFactory;
    this.UsersModel = UsersModel;
    this.$window = $window;
    this.currentUser = UserService.getCurrentUser();
    this.date = $stateParams.date;
    this.printingRmv = false;
    this.rmvSheetsAvailable =
      ((this.currentUser.school || {}).address || {}).state === "MA";
    this.viewCourse = this.viewCourse.bind(this);
    this.printRmvInCarSheet = this.printRmvInCarSheet.bind(this);
    this.agendaData = {
      instructor_id: this.currentUser.id,
      date: $stateParams.date,
    };

    this.cardLabels = [
      { class: "attn-text", name: "ACTION REQUIRED" },
      { class: "open-text", name: "OPEN SESSION" },
      { class: "rto-text", name: "RTO" },
      { class: "event-text", name: "EVENT" },
      { class: "course-text", name: "COURSE" },
    ];

    sessionTypes.forEach((type) => {
      this.cardLabels.push({
        name: type.name.toUpperCase(),
        class: type.name.replace(/\s/g, "-").toLowerCase() + "-text",
      });
    });

    CalendarModel.getInstructorAgenda(this.agendaData).then((response) => {
      const _allItems = [];
      if (typeof response.data.drives !== "undefined") {
        response.data.drives
          .filter((drive) => {
            drive.date = drive.drive_date;
            drive.startTime = formatTimeString(drive.start_time);
            drive.typeDisplay = drive.type.name;
            drive.type = "Drive Session";
            if (drive.private === "Y") {
              drive.typeDisplay = drive.typeDisplay + " (Hidden)";
            }
            drive.timestamp = getUnixTimestamp(
              new Date(drive.drive_date + " " + drive.start_time),
            );
            if (drive.location) {
              drive.location.address = drive.location.address;
            }

            if (
              drive.pickuplocation &&
              drive.pickuplocation.hasOwnProperty("address")
            ) {
              drive.pickuplocation.address = drive.pickuplocation.address;
            }
            if (
              drive.dropofflocation &&
              drive.dropofflocation.hasOwnProperty("address")
            ) {
              drive.dropofflocation.address = drive.dropofflocation.address;
            }

            const endTime = addMinutes(
              timeStringToDate(drive.start_time),
              drive.session_length,
            );
            drive.endTime = formatDateTime(endTime, "h:mm A");

            drive.duration = formatDuration(drive.session_length);

            drive.styling = CalendarModel.getStylingForDriveCard(drive);
            return drive;
          })
          .forEach((drive) => {
            _allItems.push(drive);
          });
      }

      if (typeof response.data.courses !== "undefined") {
        response.data.courses
          .filter((course) => {
            course.type = "Course";
            course.typeDisplay = course.name;
            course.location = angular.fromJson(course.location);
            course.timestamp = getUnixTimestamp(
              new Date(
                formatDateTime(new Date(course.date), "YYYY-MM-DD") +
                  " " +
                  course.time,
              ),
            );
            const endTime = addMinutes(
              timeStringToDate(course.time),
              course.duration,
            );
            course.endTime = formatDateTime(endTime, "h:mm A");

            course.startTime = formatTimeString(course.time);
            course.duration = formatDuration(course.duration);

            course.styling = "course";
            return course;
          })
          .forEach((course) => {
            _allItems.push(course);
          });
      }

      if (typeof response.data.events !== "undefined") {
        response.data.events
          .filter((event) => {
            event.typeDisplay = "Event";

            event.type = "Event";
            event.location = angular.fromJson(event.location);
            event.timestamp = getUnixTimestamp(
              new Date(
                formatDateTime(new Date(event.date), "YYYY-MM-DD") +
                  " " +
                  event.time,
              ),
            );

            const endTime = addMinutes(
              timeStringToDate(event.time),
              event.duration,
            );
            event.endTime = formatDateTime(endTime, "h:mm A");

            event.startTime = formatTimeString(event.time);
            event.duration = formatDuration(event.duration);

            event.styling = "event";
            return event;
          })
          .forEach((event) => {
            _allItems.push(event);
          });
      }

      if (typeof response.data.timeoffrequests !== "undefined") {
        response.data.timeoffrequests
          .filter((rto) => {
            rto.typeDisplay = "RTO";

            const _start_ = new Date(rto.begin);
            const _end_ = new Date(rto.end);

            rto.timestamp = getUnixTimestamp(_start_);

            rto.styling = "rto";

            // Dont show times for full or range type RTO
            if (rto.type === "full" || rto.type === "range") {
              const startOfToday = startOfDay(dateStringToDate(this.date));
              const endOfToday = endOfDay(dateStringToDate(this.date));
              rto.endTime = formatDateTime(endOfToday, "h:mm A");
              rto.startTime = formatDateTime(startOfToday, "h:mm A");
              rto.duration = formatDuration(
                differenceInMinutes(endOfToday, startOfToday),
              );
            } else {
              rto.endTime = formatDateTime(_end_, "h:mm A");
              rto.startTime = formatDateTime(_start_, "h:mm A");
              rto.duration = formatDuration(
                differenceInMinutes(_end_, _start_),
              );
            }
            return rto;
          })
          .forEach((rto) => {
            _allItems.push(rto);
          });
      }

      this.items = sortBy(_allItems, (item) => {
        return item.timestamp;
      });
    });
  }

  next() {
    this.$state.go("drivecoach.instructor.dashboard.agenda", {
      date: formatDateTime(
        addDays(dateStringToDate(this.date), 1),
        "YYYY-MM-DD",
      ),
    });
  }

  prev() {
    this.$state.go("drivecoach.instructor.dashboard.agenda", {
      date: formatDateTime(
        subtractDays(dateStringToDate(this.date), 1),
        "YYYY-MM-DD",
      ),
    });
  }

  today() {
    this.$state.go("drivecoach.instructor.dashboard.agenda", {
      date: formatDateTime(new Date(), "YYYY-MM-DD"),
    });
  }

  print() {
    this.$window.print();
  }

  printRmvInCarSheet() {
    this.printingRmv = true;
    this.UsersModel.getInstructorRmvInCarSheet(this.currentUser.id, {
      date: this.date,
    })
      .then((response) => {
        this.printingRmv = false;
        saveToDisk(response.file.url, response.file.name);
      })
      .catch(() => {
        this.printingRmv = false;
      });
  }

  isEvent(item) {
    return item.type === "Event";
  }

  isCourse(item) {
    return item.type === "Course";
  }

  viewCourse(course) {
    // This makes sure that when viewing a single course from this screen, the first classdate is selected
    if (course.classes.length > 0) {
      const data = {
        id: course.id,
        date: new Date(course.classes[0].start).toLocaleDateString(),
        class_id: course.classes[0].id,
        start: new Date(course.classes[0].start).toLocaleTimeString("en-US", {
          hour: "numeric",
          minute: "numeric",
        }),
        end: new Date(course.classes[0].end).toLocaleTimeString("en-US", {
          hour: "numeric",
          minute: "numeric",
        }),
        instructor: course.classes[0].instructor,
        instructor_id: course.classes[0].instructor_id,
      };
      this.VueStoreFactory.dispatch("SET_VIEW_COURSE", data);
    }
    this.$state.go("drivecoach.instructor.dashboard.course.view", {
      courseId: course.id,
    });
  }
}

InstructorAgendaController.$inject = [
  "UserService",
  "$state",
  "$stateParams",
  "CalendarModel",
  "$window",
  "sessionTypes",
  "VueStoreFactory",
  "UsersModel",
];
export default InstructorAgendaController;
